const state = {
    orders: [],
    error: null,
    editOrder: false
};

export default state;
